export default __webpack_public_path__ + "static/media/sugarcrm.a4f86e8e.svg";